import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api/types";
import { FileExtendedView } from "types/file";
import { PaginatedResults } from "types/pagination";

const GetUserFiles: ApiQueryConfig<
  ApiResponse<PaginatedResults<FileExtendedView>>,
  { societyId: string; profileId: string },
  Record<string, unknown>
> = {
  apiPath: "/api/v1/society/{societyId}/profiles/{profileId}/files",
  queryKey: { baseQueryKey: ["GetUserFiles"], dynamicQueryKey: ["profileId"] },
};

export { GetUserFiles };
